/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { DividerSection, FeaturePanelsSection } from "@cosmos/components";

import { VStack } from "@panda/jsx";

import type { FeaturePanelsSectionFragment } from "@cosmos/hygraph-schema";

export interface PartnerCaseStudiesProps {
	section: FeaturePanelsSectionFragment;
}

/**
 * Case-studies band for the Service Partner detail page — the partner's case
 * studies rendered as a `FeaturePanelsSection` fenced by dividers above and
 * below. The caller renders this only when a case-study section exists.
 */
export function PartnerCaseStudies({ section }: PartnerCaseStudiesProps): React.JSX.Element {
	return (
		<VStack gap="0">
			<DividerSection />
			<FeaturePanelsSection {...section} />
			<DividerSection />
		</VStack>
	);
}
